export default "__VITE_ASSET__DmVnO$aj__"